import React, { useMemo } from "react";
import { Box, CssBaseline } from "@mui/material";
import AppHeader from "./AppHeader";
import AppSidebar from "./AppSidebar";
import { useParams } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import ModuleController from "../controller/ModuleController";
import { useAppColorMode } from "../hooks/colorMode";

const ModuleLayout = () => {
  const { moduleName } = useParams();
  const { colorMode, toggleColorMode } = useAppColorMode();
  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: colorMode,
          primary: {
            main: colorMode === "dark" ? "#9fb7ff" : "#54719d",
          },
          secondary: {
            main: "#005aaa",
          },
          success: {
            main: "#4ba046",
          },
          warning: {
            main: "#e66e23",
          },
          background: {
            default: colorMode === "dark" ? "#090b12" : "#f7f8fb",
            paper: colorMode === "dark" ? "#101521" : "#ffffff",
          },
        },
        typography: {
          fontSize: 12,
          fontFamily: ["Montserrat", "sans-serif"].join(","),
        },
      }),
    [colorMode]
  );
  const hasSidebar = moduleName && moduleName !== "reset-password";

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          backgroundColor: theme.palette.background.default,
          height: "100vh",
          width: "100vw",
          overflow: "hidden",
        }}
      >
        <CssBaseline />
        <AppHeader
          moduleAppBar={hasSidebar}
          colorMode={colorMode}
          toggleColorMode={toggleColorMode}
        />
        {hasSidebar && <AppSidebar />}
        <Box
          sx={{
            width: hasSidebar ? "calc(100vw - 80px)" : "100%",
            height: "calc(100vh - 64px)",
            top: "64px",
            overflow: "auto",
            position: "relative",
            // minWidth: "1200px",
            p: hasSidebar ? 2 : 0,
          }}
        >
          <ModuleController />
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default ModuleLayout;
